import React from 'react';

import './previous-translations-list.styles.scss';

export default function PreviousTranslationsList({ previousTranslations }) {
    return (
        <div className={`${(previousTranslations && previousTranslations.length > 0) ? 'mb-4' : ''}`}>
            {(previousTranslations && previousTranslations.length > 0) && <h6 className='translation-section-title text-muted'>Related translations</h6>}
            {previousTranslations && previousTranslations.map((translation, index) => (
                <div key={index} className='previous-translation'>
                    <div className='previous-translation-text text-muted original-text'>{translation.label}</div>
                    <div className='previous-translation-text localized-text'>{translation.localized_text}</div>
                </div>
            ))}
        </div>
    )
}